export default __webpack_public_path__ + "static/media/desk.bd8ee5fa.png";